<template>
	<el-tabs v-model="activeName" type="card">
		<el-tab-pane label="文件上传" name="first">
			<el-row>
        <div>
          <el-form :model="detail" ref="form" label-width="160px">
            <!--<el-form-item label="Operation  Name" prop="sName">
              <el-input v-model="detail.sOperationName" placeholder="" style="width:220px;"></el-input>
            </el-form-item>-->
            <el-form-item label="File Name" prop="sFileName">
              <el-input v-model="detail.sFileName" readonly disabled placeholder="Please select file(excel)" style="width:220px;"></el-input>
              <el-button class="upload-button">
                Select
                <input @change="changeFile" id="files" type="file" />
              </el-button>
            </el-form-item>
            <el-form-item label="结存版本号" prop="sVersion">
              <el-select v-model="sVersion" clearable placeholder="Select">
                <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="指标名称" prop="sName">
              <el-select v-model="sName" clearable placeholder="Select">
                <el-option v-for="item in options2" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="模板名称" prop="nTemplateId">
              <el-select v-model="nTemplateId" clearable placeholder="Select">
                <el-option v-for="item in options3" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <!-- <el-button @click="doDownLoad" >Download Template</el-button> -->
              <el-button type="primary" @click="saveTemplate">Confirm</el-button>
            </el-form-item>
          </el-form>

        </div>

			</el-row>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
import {
  selectUploadTemplatePage,
  selectTemplateFieldList,
  importTemplate,
  getUploadTemplateByRoleListPage,
  getCurrencyCheckRulePage,
  importWellness, getLock
} from '../../api/api';
export default {
	data() {
		return {
			activeName: 'first',
			addTemplateFlag: false,
			detailViewFlag: false,
			filters: {
				pageSize: 10,
				currentPage: 1
			},
			form: {},
			detail: {
				sRadio: '',
				sFileFormat: '',
				nTemplateId: '',
				sDelimiters: '',
				sFileName: '',
				sOperationName: ''
			},
			total: 0,
      sVersion: '',
      sName: '',
      nTemplateId: '',
			options1: [
			],
			options2: [
        {
          id:'1-Distributor Sell in含EC 100%分解到客户指标',
          name:'1-Distributor Sell in含EC 100%分解到客户指标'
        },
        {
          id:'2-Distributor Sell out含EC 100%分解到客户指标',
          name:'2-Distributor Sell out含EC 100%分解到客户指标'
        },
        {
          id:'3-T2购进指标',
          name:'3-T2购进指标'
        },
        {
          id:'4-T3 Nonchain购进指标',
          name:'4-T3 Nonchain购进指标'
        },
        {
          id:'5-T2/T3 Nonchain售出到BMM渠道指标',
          name:'5-T2/T3 Nonchain售出到BMM渠道指标'
        },
        {
          id:'6-T2/T3 Nonchain售出到BRM渠道指标',
          name:'6-T2/T3 Nonchain售出到BRM渠道指标'
        },
        {
          id:'7-DM BMM UL指标',
          name:'7-DM BMM UL指标'
        },
        {
          id:'8-医院和互联网医院购进指标',
          name:'8-医院和互联网医院购进指标'
        },
        {
          id:'9-地区主任/专员 BRM 批发 UL指标',
          name:'9-地区主任/专员 BRM 批发 UL指标'
        },
        {
          id:'10-地区主任/专员 BRM 非批发UL指标',
          name:'10-地区主任/专员 BRM 非批发UL指标'
        },
        {
          id:'11-Dealer Sell in 100%分解到客户指标',
          name:'11-Dealer Sell in 100%分解到客户指标'
        },
        {
          id:'12-Dealer Sell out 100%分解到客户指标',
          name:'12-Dealer Sell out 100%分解到客户指标'
        },
        {
          id:'13-保健品 Sell in 100%分解到客户指标',
          name:'13-保健品 Sell in 100%分解到客户指标'
        },
        {
          id:'14-保健品 Sell out 100%分解到客户指标',
          name:'14-保健品 Sell out 100%分解到客户指标'
        },
        {
          id:'15-Oral Pharmacy Sell in',
          name:'15-Oral Pharmacy Sell in'
        },
        {
          id:'16-Oral Pharmacy Sell out',
          name:'16-Oral Pharmacy Sell out'
        },
        {
          id:'17-T3 Chain二级分部购进指标',
          name:'17-T3 Chain二级分部购进指标'
        },
        {
          id:'18-T3 Chain门店Endcon指标',
          name:'18-T3 Chain门店Endcon指标'
        },
        {
          id:'19-T客户购进指标',
          name:'19-T客户购进指标'
        },
        {
          id:'20-直接单体门店购进指标',
          name:'20-直接单体门店购进指标'
        },
        {
          id:'21-SR岗位Endcon指标',
          name:'21-SR岗位Endcon指标'
        },
        {
          id:'22-O2O GTV指标',
          name:'22-O2O GTV指标'
        },
			],
			options3: [
				{
					id: '0',
					name: 'Null Able'
				},
				{
					id: '1',
					name: 'Not Null'
				}
			],
			options4: [
				{
					id: '1',
					name: 'Using'
				},
				{
					id: '2',
					name: '='
				},
				{
					id: '3',
					name: 'In'
				}
			],
			options5: [],
			tableData: []
		};
	},
	mounted() {
    this.getSelectList();
	},
	methods: {
    // 获取 结存版本号 指标名称 模板名称
    getSelectList () {
      this.options1 = [];
      this.options2 = [];
      this.options3 = [];
      getLock({"a": "a"}).then(res => {
      this.options1 = res.data['lockList'];
      this.options2 = res.data['targetList'];
      this.options3 = res.data['templateList'];
    });
    },
		saveTemplate() {
			var fdata = new FormData();

			fdata.append('file', document.getElementById('files').files[0]);
			fdata.append('sVersion', this.sVersion);
      fdata.append('sName', this.sName);
      fdata.append('nTemplateId', this.nTemplateId);

			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});

      importWellness(fdata)
				.then(res => {
					this.$message('import Success');
					this.addTemplateFlag = false;
					loading.close();
				})
				.catch(() => {
					loading.close();
				});
		},
		doDownLoad() {
				var alink = document.createElement('a');
				alink.setAttribute('href', "./down.xlsx");
				alink.target = '_blank';
				// alink.download = './down.xlsx';
				alink.click();
		},
		changeFile(e) {
			var self = this;
			var files = document.getElementById('files').files;
			if (files.length) {
				var file = files[0];
				self.detail.sFileName = file.name;
				var arr = file.name.split('.');
				if ('xls;xlsx;'.indexOf(arr[arr.length - 1]) === -1) {
					self.$message({
						message: 'Please Select right file',
						type: 'error',
						duration: 5 * 1000
					});
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped="scoped">
.upload-button {
	position: relative;
	input {
		position: absolute;
		opacity: 0;
		width: 100%;
		height: 100%;
		z-index: 10;
		top: 0;
		left: 0;
	}
}
</style>



// WEBPACK FOOTER //
// tupload.vue?0cd37e16